import createIcon from '../../createIcon';

/**
 * @component @name SwipeRightAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuOSAxMUMxMi40NCA4LjcyIDEwLjQyIDcgOCA3QzUuMjQgNyAzIDkuMjQgMyAxMkMzIDE0Ljc2IDUuMjQgMTcgOCAxN0MxMC40MiAxNyAxMi40NCAxNS4yOCAxMi45IDEzSDE3LjE3TDE1LjU4IDE0LjU5TDE3IDE2TDIxIDEyTDE3IDhMMTUuNTkgOS40MUwxNy4xNyAxMUgxMi45WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwipeRightAlt = createIcon('SwipeRightAlt', [
  [
    'path',
    {
      d: 'M12.9 11C12.44 8.72 10.42 7 8 7C5.24 7 3 9.24 3 12C3 14.76 5.24 17 8 17C10.42 17 12.44 15.28 12.9 13H17.17L15.58 14.59L17 16L21 12L17 8L15.59 9.41L17.17 11H12.9Z',
      key: '10l73g',
    },
  ],
]);

export default SwipeRightAlt;
